<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app width="340">

      <v-list>
        <v-list-item to="/home">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        
        <!--<v-list-item>
          <v-list-item-action>
            <v-icon>mdi-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title><a href="https://dalico.info/intellectual-outputs/" target="_blank">Projects of DaLiCo</a></v-list-item-title>
          </v-list-item-content>
        </v-list-item>-->

        <v-list-group value="true" prepend-icon="mdi-school" >
          <template v-slot:activator>
            <v-list-item-title>Summer School 2020</v-list-item-title>
          </template>

          <v-list-item to="/projects2020">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Projects 2020</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/programme">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Programme 2020</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/resources">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Resources</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        
        <v-list-group value="true" prepend-icon="mdi-school" >
          <template v-slot:activator>
            <v-list-item-title>Summer School 2021</v-list-item-title>
          </template>

          <v-list-item to="/projects2021">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Projects 2021</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/programme2021">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Programme 2021</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

         <!-- <v-list-item to="/resources">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Resources</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->

          <!--<v-list-item to="/organisationalmatters">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Organisational Matters</v-list-item-title>
            </v-list-item-content>
          </v-list-item>-->
        </v-list-group>

        <v-list-group value="true" prepend-icon="mdi-school" >
          <template v-slot:activator>
            <v-list-item-title>Summer School 2022</v-list-item-title>
          </template>

          <v-list-item to="/projects2022">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Projects 2022</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/programme2022">
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Programme 2022</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-img src="dalico_logo.png" style="max-width:90px; background-color: white"/>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <v-footer color="primary" app>
      <v-row>
        <v-col md="2" cols="12">
          <span class="white--text" style="padding-right: 20px">&copy; {{ new Date().getFullYear() }}</span>
          <router-link to="/imprint" class="white--text">Imprint</router-link>
        </v-col>
        <v-col md="5" cols="12">
          <p style="font-size: x-small; color:white;">
            This project has been funded with support from the European Commission.
            This publication reflects the views only of the author.
            Neither the European Commission nor the project's national funding agency DAAD are responsible for the content or liable for any losses or damage resulting of the use of these resources.
          </p>
        </v-col>
        <v-col md="5" cols="12">
          <v-img src="erasmusleft_en_small.jpg" aspect-ratio="4.55" max-height="60px" contain/>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
  }
</script>
